import { AlertTriangle } from 'lucide-react';
import React from 'react';

import { Button } from '@/components/ui/button';

interface V2ShortfallPromptProps {
    /** USDC the order needs beyond what the account has free. */
    shortfall: number;
    onDeposit: () => void;
}

/**
 * The browser wallet flow's (V2) stand-in for `InsufficientCustodialBanner`: the order needs more USDC than the
 * Snappy Wallet has free on Hyperliquid. One line and a Deposit button, which opens the V2 funds panel through the
 * shared panel store. Static and tiny on purpose: the trade rail imports it in both flows.
 */
const V2ShortfallPrompt: React.FC<V2ShortfallPromptProps> = ({
    shortfall,
    onDeposit,
}) => (
    <div
        role="status"
        className="flex items-center justify-between gap-3 rounded-lg border border-amber-500/30 bg-amber-500/5 px-3 py-2"
    >
        <p className="flex min-w-0 items-center gap-2 text-[11px] text-amber-400">
            <AlertTriangle size={14} className="shrink-0" />
            <span>
                Need{' '}
                <span className="font-mono tabular-nums">
                    ${shortfall.toFixed(2)}
                </span>{' '}
                more for this order.
            </span>
        </p>
        <Button size="sm" onClick={onDeposit} className="shrink-0">
            Deposit
        </Button>
    </div>
);

V2ShortfallPrompt.displayName = 'V2ShortfallPrompt';

export default V2ShortfallPrompt;
